import { register } from "async-ops";
import { callMvcApi  } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const GET_PROCESS_TEMPLATE_LIST = 'GET_PROCESS_TEMPLATE_LIST';


export const service = async (data) => {
  const options: object = {
    url:  '/Api/ProcessTemplate/GetProcessTemplateList',
    method: "GET",
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_PROCESS_TEMPLATE_LIST, service, mock);
